// extracted by mini-css-extract-plugin
module.exports = {"companyContact":"company-contact-company-contact-companyContact-d460bffc"};